import { render, staticRenderFns } from "./CorporateNavigation.vue?vue&type=template&id=36d4fb99&scoped=true"
import script from "./CorporateNavigation.vue?vue&type=script&lang=ts"
export * from "./CorporateNavigation.vue?vue&type=script&lang=ts"
import style0 from "./CorporateNavigation.vue?vue&type=style&index=0&id=36d4fb99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d4fb99",
  null
  
)

export default component.exports